import React, { useEffect, useState } from "react";
import "./resetPassword.scss";
import authStore from "../../store/authStore";
import brandStore from "../../store/brandStore";
import { Link, useNavigate } from "react-router-dom";
import {
  Box,
  Grid,
  IconButton,
  InputAdornment,
  Stack,
  TextField,
} from "@mui/material";
import { LoadingButton } from "@mui/lab";

// Icons
import Visibility from "@mui/icons-material/Visibility";
import VisibilityOff from "@mui/icons-material/VisibilityOff";
import { BRAND_NAME_LOGO } from "../../constant";
import SEO from "components/seo/SEO";

const ResetPassword = () => {
  const AuthStore = authStore();
  const BrandStore = brandStore();
  const navigate = useNavigate();

  const [isLoading, setIsLoading] = useState(false);

  // current password
  const [showCurrentPassword, setShowCurrentPassword] = useState(false);
  const [isCurrentPasswordError, setIsCurrentPasswordError] = useState(false);
  const [currentPasswordMassage, setCurrentPasswordMassage] = useState("");
  const [currentPassword, setCurrentPassword] = useState("");
  // current password

  // new password
  const [showNewPassword, setShowNewPassword] = useState(false);
  const [isNewPasswordError, setIsNewPasswordError] = useState(false);
  const [newPasswordMassage, setNewPasswordMassage] = useState("");
  const [newPassword, setNewPassword] = useState("");
  // new password

  // new confirm password
  const [showConfirmNewPassword, setShowConfirmNewPassword] = useState(false);
  const [isConfirmNewPasswordError, setIsConfirmNewPasswordError] =
    useState(false);
  const [confirmNewPasswordMassage, setConfirmNewPasswordMassage] =
    useState("");
  const [confirmNewPassword, setConfirmNewPassword] = useState("");
  // new confirm password

  useEffect(() => {
    window.scrollTo({ top: 0 });
    if (AuthStore.whereNavigate === null) {
      navigate("/", { replace: true });
    } else {
      if (AuthStore.whereNavigate === "forgot-password") {
        setCurrentPassword(AuthStore.myOldPassword);
      }
    }
  }, []);

  const handleMouseDownPassword = (event) => {
    event.preventDefault();
  };

  const validate = () => {
    let flag = 0;
    let matchPassword = false;
    if (currentPassword === "") {
      setCurrentPasswordMassage("current password is require");
      setIsCurrentPasswordError(true);
      flag++;
    } else {
      setIsCurrentPasswordError(false);
    }

    if (newPassword === "") {
      setNewPasswordMassage("new password is require");
      setIsNewPasswordError(true);
      flag++;
    } else {
      if (newPassword.length >= 8 && newPassword.length <= 18) {
        setIsNewPasswordError(false);
        matchPassword = true;
      } else {
        setNewPasswordMassage("password must be 8 to 18 digit");
        setIsNewPasswordError(true);
        matchPassword = false;
        flag++;
      }
    }

    if (confirmNewPassword === "") {
      setConfirmNewPasswordMassage("confirm password is require");
      setIsConfirmNewPasswordError(true);
      flag++;
    } else {
      setIsConfirmNewPasswordError(false);
    }

    if (newPassword !== "" && confirmNewPassword !== "" && matchPassword) {
      if (newPassword === confirmNewPassword) {
        setIsConfirmNewPasswordError(false);
      } else {
        setConfirmNewPasswordMassage("not match with new password");
        setIsConfirmNewPasswordError(true);
        flag++;
      }
    }

    if (flag === 0) {
      return true;
    } else {
      return false;
    }
  };

  const onSubmit = async () => {
    const isValid = validate();

    if (!isValid) return;
    setIsLoading(true);

    let res = null;

    if (AuthStore.whereNavigate === "forgot-password") {
      res = await AuthStore.changeForgotUserPassword({
        email: AuthStore.isOTPScreenEmail.trim(),
        newPassword: newPassword.trim(),
      });
    } else {
      res = await AuthStore.changeUserPassword({
        email: AuthStore.isOTPScreenEmail.trim(),
        password:
          AuthStore.whereNavigate !== "forgot-password"
            ? currentPassword
            : currentPassword.trim(),
        newPassword: newPassword.trim(),
      });
    }

    if (res.status === 1) {
      navigate(-1, { replace: true });
    } else if (res.status === 0) {
      setCurrentPasswordMassage(res.message);
      setIsCurrentPasswordError(true);
    } else if (res.status === 2) {
      setNewPasswordMassage(res.message);
      setIsNewPasswordError(true);
    } else if (res.status === 3) {
      alert("user not found");
    }
    setIsLoading(false);
  };

  return (
    <div className="reset-password">
      <SEO
        title="Reset Password | KRISTIVE"
        description="Securely reset your KRISTIVE password. Create a new password to regain access to your account and favorite fragrances."
        noFollow
        noIndex
        noImageIndex
      />
      <Grid container sx={{ display: "flex", justifyContent: "center" }}>
        <Grid item md={6} sm={8} xs={12}>
          <Stack spacing={2}>
            <Box component="div" className="brand-name-logo-container">
              <Link to={"/"} component="div" className="brand-name-logo">
                <img src={BRAND_NAME_LOGO} alt="brand-logo" />
              </Link>
            </Box>
            <div className="title">
              {AuthStore.whereNavigate !== "forgot-password"
                ? "Set New Password"
                : "Reset Password"}
            </div>
            {AuthStore.whereNavigate !== "forgot-password" && (
              <TextField
                id="currentPassword"
                name="currentPassword"
                required
                fullWidth
                type={showCurrentPassword ? "text" : "password"}
                label="Current Password"
                autoComplete="password"
                InputProps={{
                  endAdornment: (
                    <InputAdornment position="end">
                      <IconButton
                        onClick={() =>
                          setShowCurrentPassword(!showCurrentPassword)
                        }
                        onMouseDown={handleMouseDownPassword}
                        edge="end"
                      >
                        {showCurrentPassword ? (
                          <VisibilityOff />
                        ) : (
                          <Visibility />
                        )}
                      </IconButton>
                    </InputAdornment>
                  ),
                }}
                error={isCurrentPasswordError}
                helperText={isCurrentPasswordError && currentPasswordMassage}
                value={currentPassword}
                onChange={(e) => setCurrentPassword(e.target.value)}
              />
            )}

            <TextField
              id="newPassword"
              name="newPassword"
              required
              fullWidth
              type={showNewPassword ? "text" : "password"}
              label="New Password"
              autoComplete="password"
              InputProps={{
                endAdornment: (
                  <InputAdornment position="end">
                    <IconButton
                      onClick={() => setShowNewPassword(!showNewPassword)}
                      onMouseDown={handleMouseDownPassword}
                      edge="end"
                    >
                      {showNewPassword ? <VisibilityOff /> : <Visibility />}
                    </IconButton>
                  </InputAdornment>
                ),
              }}
              error={isNewPasswordError}
              helperText={isNewPasswordError && newPasswordMassage}
              value={newPassword}
              onChange={(e) => setNewPassword(e.target.value)}
            />
            <TextField
              id="confirmNewPassword"
              name="confirmNewPassword"
              required
              fullWidth
              type={showConfirmNewPassword ? "text" : "password"}
              label="Confirm Password"
              autoComplete="password"
              InputProps={{
                endAdornment: (
                  <InputAdornment position="end">
                    <IconButton
                      onClick={() =>
                        setShowConfirmNewPassword(!showConfirmNewPassword)
                      }
                      onMouseDown={handleMouseDownPassword}
                      edge="end"
                    >
                      {showConfirmNewPassword ? (
                        <VisibilityOff />
                      ) : (
                        <Visibility />
                      )}
                    </IconButton>
                  </InputAdornment>
                ),
              }}
              error={isConfirmNewPasswordError}
              helperText={
                isConfirmNewPasswordError && confirmNewPasswordMassage
              }
              value={confirmNewPassword}
              onChange={(e) => setConfirmNewPassword(e.target.value)}
            />
            <LoadingButton
              loading={isLoading}
              className="btn"
              variant="contained"
              type="submit"
              onClick={onSubmit}
            >
              Submit
            </LoadingButton>
          </Stack>
        </Grid>
      </Grid>
    </div>
  );
};

export default ResetPassword;
